import login from './login';
import applyFor from './applyFor';
import InterviewPanel from './InterviewPanel';
import Calendar from './Calendar';
import common from './common';

const config = {
  login,
  applyFor,
  InterviewPanel,
  Calendar,
  common,
};

export default config;
